import { api } from './apiService';

export const cryptoPriceApiService = {
  async getHistoricalPrice(cryptoId: string, date: string): Promise<number | null> {
    const { data } = await api.get<{ price: number | null }>('/crypto-prices/historical', {
      params: { cryptoId, date },
    });
    return data.price;
  },
};
